export const LoginActionConst = {
  USER_LOGIN_REQUEST: "USER_LOGIN_REQUEST",
  USER_LOGIN_SUCC: "USER_LOGIN_SUCC",
  USER_LOGIN_FAIL: "USER_LOGIN_FAIL",
  USER_LOGOUT: "USER_LOGOUT",
  CLEAR_LOGIN_STATES: "CLEAR_LOGIN_STATES",
};

export const SignupActionConst = {
  USER_SIGNUP_REQUEST: "USER_SIGNUP_REQUEST",
  USER_SIGNUP_SUCC: "USER_SIGNUP_SUCC",
  USER_SIGNUP_FAIL: "USER_SIGNUP_FAIL",
};

export const OTPActionConst = {
  SET_PENDING_EMAIL_FOR_OTP: "SET_PENDING_EMAIL_FOR_OTP",
  CLEAR_PENDING_EMAIL_FOR_OTP: "CLEAR_PENDING_EMAIL_FOR_OTP",
  VERIFY_EMAIL_REQUEST: "VERIFY_EMAIL_REQUEST",
  VERIFY_EMAIL_SUCCESS: "VERIFY_EMAIL_SUCCESS",
  VERIFY_EMAIL_FAIL: "VERIFY_EMAIL_FAIL",
};

export const PasswordOtpActionConst = {
  SET_PENDING_EMAIL: "SET_PENDING_EMAIL_FOR_PASSWORD_OTP",
  CLEAR_PENDING_EMAIL: "CLEAR_PENDING_EMAIL_FOR_PASSWORD_OTP",
  SET_PENDING_OTP: "SET_PENDING_OTP_FOR_PASSWORD_RESET",
  CLEAR_PENDING_OTP: "CLEAR_PENDING_OTP_FOR_PASSWORD_RESET",
  REQUEST_CODE: "PASSWORD_OTP_REQUEST_CODE",
  REQUEST_CODE_SUCCESS: "PASSWORD_OTP_REQUEST_CODE_SUCCESS",
  REQUEST_CODE_FAIL: "PASSWORD_OTP_REQUEST_CODE_FAIL",
  VERIFY_REQUEST: "PASSWORD_OTP_VERIFY_REQUEST",
  VERIFY_SUCCESS: "PASSWORD_OTP_VERIFY_SUCCESS",
  VERIFY_FAIL: "PASSWORD_OTP_VERIFY_FAIL",
  RESET_REQUEST: "PASSWORD_OTP_RESET_REQUEST",
  RESET_SUCCESS: "PASSWORD_OTP_RESET_SUCCESS",
  RESET_FAIL: "PASSWORD_OTP_RESET_FAIL",
  CLEAR_STATUS: "PASSWORD_OTP_CLEAR_STATUS",
};

